import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth-security/auth.service';
import { AppGeneralStateService } from './app-general-state.service';
import { MatDialog } from '@angular/material/dialog';
import { LotSelectComponent } from './core/dialog/lots/lot-select/lot-select.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  navbarClass: string = '';
  aceEnvironment: string = '';
  notifications: { id: number; message: string }[] = [
    { id: 1, message: 'Invoice 104582 needs review.' },
    { id: 2, message: 'Lot 17 access request is waiting for approval.' },
  ];

  //SERVICES

  private _routerService = inject(Router);
  public _authState = inject(AuthService);
  public _appGeneralState = inject(AppGeneralStateService);
  private _matDialog = inject(MatDialog);

  constructor() {
    // 20240903 :: Ken Moss
    // Changed environment settings to a service on appGeneralState instead of pulling from environment.ts each time.

    const aceParkUrl = environment.AceParkUrl;

    if (aceParkUrl == 'www.acepark.net') {
      this._appGeneralState.isEnvironmentDev = false;
    } else this._appGeneralState.isEnvironmentDev = true;

    if (this._appGeneralState.isEnvironmentDev) {
      this.navbarClass = 'ace-navbar-dev';
    } else {
      this.navbarClass = 'ace-navbar-production';
    }
  }

  onNavToHome(): void {
    const aceUrl: string = environment.AceParkUrl;

    window.location.href = `https://${aceUrl}`;
  }

  onLogOut(): void {
    const aceUrl: string = environment.AceParkUrl;

    window.location.href = `https://${aceUrl}/home/logoff/auto`;
  }

  onChooseLot(): void {
    const dlgTitle: string = '';
    const dlgLine1: string = '';
    const dlgLine2: string = '';
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogRef = this._matDialog.open(LotSelectComponent, {
      data: { dlgTitle: dlgTitle, dlgLine1: dlgLine1, dlgLine2: dlgLine2 },
      width: '850px',
      height: '500px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  onNavToSearchSnacks(): void {
    this._routerService.navigateByUrl('/searchsnacks');
  }

  isViewInvoiceRoute(): boolean {
    return (
      this._routerService.url.startsWith('/viewinvoice/') || this._routerService.url.startsWith('/finalizeinvoice/')
    );
  }

  dismissNotification(notificationId: number): void {
    this.notifications = this.notifications.filter((notification) => notification.id !== notificationId);
  }
}
